import Event from '../../core/Event';

export default class EstimationsPlaceRequestSent extends Event {
    public static type = 'EstimationsPlaceRequestSent';

    constructor() {
        super(EstimationsPlaceRequestSent.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsPlaceRequestSent.ts